import { Card, CardContent, Typography, Box } from "@mui/material";

function FilterSection({ title, children, icon }) {
  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          {icon}
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, color: "black" }}
          >
            {title}
          </Typography>
        </Box>
        {children}
      </CardContent>
    </Card>
  );
}

export default FilterSection;
